var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { useEffect } from "react";
import { useLazyQuery } from "@atlassiansox/microscopekit";
import { ResourceListForFaultAndServiceQuery, ResilienceFaults } from "../../../../../graphql";
var faultResourceMap = {
    rds_az_failover: ["dedicated-rds"],
    redis_az_failover: ["redis", "redis3", "redisx"]
};
export var isResourceAzFailoverFault = function (faultExecution) {
    return faultExecution !== undefined &&
        [
            ResilienceFaults.rds_az_failover,
            ResilienceFaults.redis_az_failover
        ].includes(faultExecution);
};
var getResource = function (data, resourceType) { var _a, _b, _c; return (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.resourceListForFaultAndService) === null || _a === void 0 ? void 0 : _a[resourceType]) === null || _b === void 0 ? void 0 : _b.map(function (resource) { return resourceType + " : " + resource.micros_resource_name; })) !== null && _c !== void 0 ? _c : []; };
var getResourceOptions = function (data, faultExecution) {
    var e_1, _a;
    var resourceOptions = [];
    if (isResourceAzFailoverFault(faultExecution)) {
        try {
            for (var _b = __values(faultResourceMap[faultExecution]), _c = _b.next(); !_c.done; _c = _b.next()) {
                var resourceType = _c.value;
                resourceOptions.push.apply(resourceOptions, __spread(getResource(data, resourceType)));
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    return resourceOptions;
};
export var useAzFailoverResource = function (faultExecution, service, environment) {
    var _a = __read(useLazyQuery(ResourceListForFaultAndServiceQuery), 2), getData = _a[0], _b = _a[1], loading = _b.loading, data = _b.data;
    var options = getResourceOptions(data, faultExecution);
    var defaultOption = options[0];
    useEffect(function () {
        if (isResourceAzFailoverFault(faultExecution)) {
            getData({
                variables: {
                    service: service,
                    environment: environment,
                    faultType: faultExecution
                }
            });
        }
    }, [faultExecution, environment, getData, service]);
    return {
        options: options,
        isLoading: loading,
        defaultOption: defaultOption
    };
};
